/**
 * ŠABLÓNA "template_2" – LANDSCAPE. Registruje sa v ../../dailyMenuTemplates.js.
 */
import React from "react";
import Template2Screen from "./Template2Screen";

export default function DailyMenuTemplate2Landscape() {
  return <Template2Screen orientation="landscape" />;
}
